var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTr25(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2894,
    height: 544,
    viewBox: "0 0 2894 544",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1575_1906)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 271.312,
    cy: 272,
    r: 271.312,
    fill: "#00AA6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 859.156,
    cy: 272,
    r: 271.312,
    fill: "#00AA6C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1695.7 272C1695.7 409.355 1584.35 520.703 1447 520.703V23.2969C1584.35 23.2969 1695.7 134.645 1695.7 272ZM1447 543.312C1596.84 543.312 1718.31 421.842 1718.31 272C1718.31 122.158 1596.84 0.6875 1447 0.6875C1297.16 0.6875 1175.69 122.158 1175.69 272C1175.69 421.842 1297.16 543.312 1447 543.312Z",
    fill: "#00AA6C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2034.84,
    cy: 272,
    r: 260.008,
    stroke: "#00AA6C",
    strokeWidth: 22.6094
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2622.69,
    cy: 272,
    r: 260.008,
    stroke: "#00AA6C",
    strokeWidth: 22.6094
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1575_1906"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2894,
    height: 542.625,
    fill: "white",
    transform: "translate(0 0.6875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTr25);
export default __webpack_public_path__ + "static/media/tr-2.5.5371ed06db9eb8071df7d46e71c79edd.svg";
export { ForwardRef as ReactComponent };